/**
 * Tutorial screen lifecycle helpers — extracted pure so the cleanup CONTRACT
 * is unit-testable without mounting Phaser (same discipline as
 * gameScreenBootStability / stageSquare).
 */

export interface TutorialCleanupDeps {
  /** The live Phaser game (or null if boot never completed). */
  game: { destroy(removeCanvas: boolean): void } | null;
  /** Cancels the scripted transport's pending emissions. */
  disposeTransport: () => void;
  /** Removes every window/observer listener the screen registered. */
  removeListeners: () => void;
}

/**
 * Builds the idempotent unmount cleanup for the tutorial screen:
 * listeners off → boot global cleared → Phaser destroyed (guarded) →
 * transport disposed. Ordering matters: the transport must outlive the
 * Phaser teardown so a late scene callback finds a disposed-but-safe
 * transport rather than a dangling one.
 */
export function createTutorialCleanup(deps: TutorialCleanupDeps): () => void {
  let done = false;
  return () => {
    if (done) return;
    done = true;
    deps.removeListeners();
    delete (window as Window & { __GAME_INIT__?: unknown }).__GAME_INIT__;
    try {
      deps.game?.destroy(true);
    } catch (err) {
      console.error('[TutorialScreen] Phaser game.destroy() threw during cleanup:', err);
    }
    deps.disposeTransport();
  };
}
